// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bQQv","buttons":"Footer_buttons__2-88D"};